import React from 'react';
import type { TrendControlsData, TrendDropdownOption } from '@app-types/performanceTrends';

export interface TrendsControlsProps {
  data: TrendControlsData;
  nodeId?: string;
  selectedForecast?: string;
  selectedPeriod?: string;
  onForecastChange?: (value: string) => void;
  onPeriodChange?: (value: string) => void;
}

interface SelectControlProps {
  label: string;
  options: TrendDropdownOption[];
  value: string;
  onChange?: (value: string) => void;
}

const SelectControl: React.FC<SelectControlProps> = ({
  label,
  options,
  value,
  onChange,
}) => (
  <div className="trends-controls__group">
    <span className="trends-controls__label">{label}</span>
    <div className="trends-controls__dropdown">
      <select
        className="trends-controls__select"
        aria-label={label}
        value={value}
        onChange={(event) => onChange?.(event.target.value)}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <span className="trends-controls__caret" aria-hidden="true">
        ▼
      </span>
    </div>
  </div>
);

const TrendsControls: React.FC<TrendsControlsProps> = ({
  data,
  nodeId,
  selectedForecast = data.selectedForecast,
  selectedPeriod = data.selectedPeriod,
  onForecastChange,
  onPeriodChange,
}) => (
  <div className="trends-controls" data-node-id={nodeId}>
    <SelectControl
      label={data.forecastLabel}
      options={data.forecastOptions}
      value={selectedForecast}
      onChange={onForecastChange}
    />
    <SelectControl
      label={data.periodLabel}
      options={data.periodOptions}
      value={selectedPeriod}
      onChange={onPeriodChange}
    />
  </div>
);

export default TrendsControls;
